import { MapProvider } from './map.provider';

export class GoogleMapProvider implements MapProvider {
  private _apiKey: string;
  private _type: string;
  constructor(apiKey: string, type: 'ROADMAP' | 'SATELLITE' | 'HYBRID' = 'SATELLITE') {
    this._apiKey = apiKey;
    this._type = type;
  }

  getName(): string {
    return 'google';
  }

  getScript(): string {
    return `https://maps.googleapis.com/maps/api/js?key=${this._apiKey}`;
  }

  addToMap(map: L.Map): void {
    map.addLayer(new (L as any).Google(this._type));
  }
}
